module.exports = __webpack_public_path__ + "img/vi-bg-one.c53e45bc.jpg";